import { useTranslation } from 'react-i18next';

import { OtpInput } from '@/common';
import { Button, Label, LABEL_TYPE } from '@/components/generic';
import { ButtonVariant } from '@/components/generic/Button/button-config';
import { TestIds } from '@/shared/test-ids';

type MfaQrStepProps = {
  qrCodeDataUrl: string;
  totpCode: string;
  onTotpChange: (value: string) => void;
  isLoading: boolean;
  onVerify: () => void;
  onSecondaryAction?: () => void;
  secondaryActionLabel?: string;
};

export const MfaQrStep = ({
  qrCodeDataUrl,
  totpCode,
  onTotpChange,
  isLoading,
  onVerify,
  onSecondaryAction,
  secondaryActionLabel
}: MfaQrStepProps) => {
  const [t] = useTranslation('common');

  return (
    <div className='flex flex-col gap-4'>
      <Label text={t('mfaStep1Title')} type={LABEL_TYPE.H3_BOLD} className='!text-base' />
      <Label
        text={t('mfaStep1Description')}
        type={LABEL_TYPE.PARAGRAPH1}
        className='!text-secondary-gray'
      />
      {qrCodeDataUrl && (
        <img
          src={qrCodeDataUrl}
          alt='MFA QR Code'
          data-testid={TestIds.mfa.qrImage}
          className='size-40 self-start rounded-lg'
        />
      )}
      <div className='h-px w-full bg-primary-black opacity-10' />
      <Label text={t('mfaStep2Title')} type={LABEL_TYPE.H3_BOLD} className='!text-base' />
      <Label
        text={t('mfaStep2Description')}
        type={LABEL_TYPE.PARAGRAPH1}
        className='!text-secondary-gray'
      />
      <OtpInput
        value={totpCode}
        onChange={onTotpChange}
        disabled={isLoading}
        testIdPrefix={TestIds.mfa.enrollOtpInput}
        onComplete={onVerify}
      />
      {onSecondaryAction && secondaryActionLabel && (
        <div className='flex gap-3'>
          <Button
            variant={ButtonVariant.SECONDARY}
            disabled={isLoading}
            handleOnClick={onSecondaryAction}
            className='w-fit'>
            {secondaryActionLabel}
          </Button>
        </div>
      )}
    </div>
  );
};
